import {
    RENTER_VIEW_PAYMENT,
    RENTER_VIEW_PAYMENT_SUCCESSFUL,
    RENTER_VIEW_PAYMENT_FAILED
} from "./actionTypes";

const initialState = {
    viewPaymentError: null,
    loading: false,
    paymentListData: null,
    isViewPaymentSuccess: false,
    isViewPaymentError: false
};


const RenterViewPayment = (state = initialState, action) => {

    switch (action.type) {
        case RENTER_VIEW_PAYMENT:
            state = {
                ...state,
                loading: true,
                viewPaymentError: null,
            };
            break;
        case RENTER_VIEW_PAYMENT_SUCCESSFUL:
            state = {
                ...state,
                loading: false,
                paymentListData: action.payload,
                isViewPaymentSuccess: true,
                viewPaymentError: null,
                isViewPaymentError: false,
            };
            break;
        case RENTER_VIEW_PAYMENT_FAILED:
            state = {
                ...state,
                paymentListData: null,
                loading: false,
                viewPaymentError: action.payload,
                isViewPaymentError: true,
                isViewPaymentSuccess: false,
            };
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
};

export default RenterViewPayment;
